var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.443 18.776a13.105 13.105 0 01-4.625 6.614A13 13 0 014 15a12.886 12.886 0 012.61-7.815 13.105 13.105 0 016.614-4.625 1 1 0 011.25 1.25 11.01 11.01 0 0013.725 13.725 1 1 0 011.25 1.25l-.006-.009z"
  })));
}
export default SvgMoonFill;